import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { discountCategoryQueries } from '@/services/discount-management/discount-category.queries';
import { useSearch } from '@tanstack/react-router';

export const useDiscountSlabs = (categoryId: string) => {
  const search = useSearch({ from: '/(app)/configuration-management/discount-management/$discountCategory/' });
  const { page, fetch, sort } = search;

  const { data, isLoading } = useQuery({
    ...discountCategoryQueries.detailList({
      categoryId: categoryId ?? '',
      row: page ?? 0,
      fetch: fetch ?? 10,
    }),
    select: (res) => {
      return {
        ...res,
        data: sortBy(res?.data, sort),
      };
    },

    enabled: Boolean(categoryId),
  });

  return { slabs: data?.data, isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
